import { ContentType, type ContentHref } from '@generalTypes/apiTypes';
import { selectApiWithPendingChanges } from '@newStore/documentApi/documentApiSelectors';
import { selectKrcAgeRangeItemChildrenByExtendedIdentifierMap } from '@newStore/documentUI/transformContent/krcContentNodeSelectors';
import { createTypedSelector } from '@newStore/genericHelpers';
import { RequiredType, type EditComponent } from '@nodeTypeConfig/configTypes';
import { pick } from 'lodash';
import { createError } from '../createError';
import type { AsideValidationRule } from '../validationTypes';

export const selectKrcGoalIdentifierUniqueValidation: AsideValidationRule = createTypedSelector(
  [
    (state, href: ContentHref) => selectApiWithPendingChanges(state).content[href],
    (state) => selectKrcAgeRangeItemChildrenByExtendedIdentifierMap(state),
    (state, href: ContentHref, parentHref: ContentHref | undefined) => parentHref,
    (state, href: ContentHref) => href,
    (state, href, parentHref, config: EditComponent) => config,
  ],
  (content, groupedChildrenMap, parentHref, href, config) => {
    const identifier = content?.identifiers?.[0]?.trim();

    if (
      !content ||
      content.type !== ContentType.KRC_CURRICULUM_GOAL ||
      !identifier ||
      !parentHref
    ) {
      return true;
    }

    const numericIdentifier = Number.parseInt(identifier, 10);
    const duplicate = (groupedChildrenMap[parentHref] || []).find(
      ({ href: childHref, identifier: childId }) =>
        childHref !== href && childId === numericIdentifier,
    );

    if (!duplicate) {
      return true;
    }

    return createError(
      'krcGoalIdentifierDuplicate',
      'selectKrcGoalIdentifierUniqueValidation',
      `Er bestaat al een <strong>doel</strong> met code <strong>${duplicate.fullIdentifier}</strong>`,
      pick(config, ['component', 'property']),
      RequiredType.ERROR,
    );
  },
);
